import { customAxios, customPatchAxios } from "./customAxios";

/**
 * 사용자 전체 목록
 * @returns 
 */
export const getUsersAll = async()=>{
  const res = await customAxios.get('/api/users');
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 사용자 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getUsersByQuery = async(query)=>{
  const res = await customAxios.get('/api/users', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 사용자 상세
 * @param {*} id 
 * @returns 
 */
export const getUsersById = async(id)=>{
  const res = await customAxios.get('/api/users/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 사용자 ID 중복확인
 * @param {*} query 
 * @returns 
 */
export const getCheckDupleLoginId = async(query)=>{
  const res = await customAxios.get('/api/users/checkDup',{params : query});
  if (res.data) {
    return res.data;
  }
  return false;
}

/**
 * 사용자 이메일 중복확인
 * @param {*} query 
 * @returns 
 */
export const getCheckDupleEmail = async(query)=>{
  const res = await customAxios.get('/api/users/checkDupEmail',{params : query});
  if (res.data) {
    return res.data;
  }
  return false;
}

/**
 * 사용자 등록
 * @param {*} body 
 */
export const postUsers = async(body)=>{
  //console.log(body);
  await customAxios.post('/api/users',body);
}

/**
 * 사용자 수정
 * @param {*} body 
 */
export const patchUsers = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/users/'+body.id, body);
}

/**
 * 사용자 삭제
 * @param {*} param 
 */
export const deleteUsers = async(param)=>{
  //console.log(param);
  await customAxios.delete('/api/users/'+param);
}
